import { merge } from 'lodash';
import { fields, name } from './schema';
import dba from 'utils/dba';
export default class Category {
  static async getAll() {
    let result = await dba.execute(`SELECT * FROM ${name}`);
    result = dba.getAll(result);
    return result;
  }

  static async databaseExit() {
    return dba.execute(`SELECT COUNT(id) as numberOfRecord FROM ${name}`);
  }

  static async deleteData() {
    return dba.execute(`DELETE FROM ${name}`);
  }

  static async create(data) {

    const sql = `INSERT INTO ${name} VALUES='@values'`; 
    return dba.executeQry(sql, data);

  }

  static toItem(data) {
 
    let result = {
      [fields.idCategory]:data.id,
      [fields.categoryCode]:data['field_73'],
      [fields.category]:data['field_2'],
    }

    return result;
  }

}
